import { Event } from '@reg/shared/model';
import { toDate } from 'date-fns';
import { DateFormat } from '@reg/shared/enum';
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz';

export class EventSuggestion {
    public eventId: string;
    public name: string;
    public locationName: string;
    public startDateTime: Date = null;
    public endDateTime: Date = null;
    public hasFocus: boolean = false;
    public formattedStartEndDate: string;

    public fillFromEvent(event: Event): EventSuggestion {
        this.eventId = event.id;
        this.name = event.name;

        if (event.location) {
            this.locationName = event.location.name;
        }

        if (event.startDateTime) {
            this.startDateTime = new Date(event.startDateTime.getTime());
        }

        if (event.endDateTime) {
            this.endDateTime = new Date(event.endDateTime.getTime());
        }

        this.formattedStartEndDate = this.formatStartEndDate();

        return this;
    }

    public fillFromSearchHit(searchHit: Object): EventSuggestion {
        if (searchHit && searchHit['fields']) {
            const fields: Object = searchHit['fields'];

            this.eventId = searchHit['id'].replace('arena_event_', '');
            this.name = this.getSearchHitField('title', fields);
            this.locationName = this.getSearchHitField('location', fields);
            const utcOffsetSeconds: number = new Date().getTimezoneOffset() * 60;

            const startTimeStamp: string = this.getSearchHitField('start_date', fields);
            if (startTimeStamp) {
                this.startDateTime = toDate(parseFloat(startTimeStamp) - utcOffsetSeconds);
            }
            const endTimeStamp: string = this.getSearchHitField('end_date', fields);
            if (endTimeStamp) {
                this.endDateTime = toDate(parseFloat(endTimeStamp) - utcOffsetSeconds);
            }

            this.formattedStartEndDate = this.formatStartEndDate();
        }

        return this;
    }

    private getSearchHitField(fieldName: string, fields: Object): string {
        if (fields[fieldName]) {
            if (Array.isArray(fields[fieldName])) {
                return fields[fieldName][0];
            }
            return fields[fieldName];
        }
        return null;
    }

    private formatStartEndDate(): string {
        const startDate: string = this.startDateTime &&
            formatInTimeZone(this.startDateTime, 'utc', DateFormat.MMDDYYYY);
        const endDate: string = this.endDateTime &&
            formatInTimeZone(this.endDateTime, 'utc', DateFormat.MMDDYYYY);
        if (startDate &&
            endDate) {
            return (startDate === endDate) ? startDate : `${startDate} - ${endDate}`;
        }

        return startDate || endDate;
    }
}
